import { Button, Modal } from "@mui/material";

const ChangePasswordInfo = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        zIndex: 9999,
        outline: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          maxWidth: "690px",
          width: "100%",
          overflow: "auto",
          borderRadius: "var(--wrapperBorderRadius)",
          outline: "none",
          maxHeight: "90vh",
          padding: "20px",
        }}
      >
        {/* <figure
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "var(--pastelBlue)",
          }}
        >
          <img
            src="/images/heros/heros.png"
            alt="iyziTeam"
            style={{ width: "100%" }}
          />
        </figure> */}
        <div
          style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap)",
          }}
        >
          
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu süre zarfı içerisinde LÜTFEN ETSY BAĞLANTINIZI IYZISHIP ile koparmayınız.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bilgilerinize
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
           Bu vesileyle Kurban Bayramınızın Mübarek olmasını dileriz. Hayırlı Bayramlar…
          </p> */}
          {/* <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Bilgilerinize…
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Saygılarımızla,
          </p> */}
          <h2
            style={{
              fontSize: "22px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "500px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            Değerli Üyelerimiz,
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            Ramazan Bayramı sebebi ile önümüzdeki günlerde çalışma düzenimiz aşağıdaki şekilde olacaktır.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            19.03.2026 Perşembe Arife Günü, öğlen 12:00'e kadar çalışma olacak ve öğleden önce 11:00'e kadar adresimize ulaşan ödemesi tamamlanmış bütün kargoların çıkışı gerçekleşecektir.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            20.03.2026 Bayramın 1.Gününden itibaren 3.Günü de dahil olmak üzere bayram boyunca operasyona ara verilecektir.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
            }}
          >
            23.03.2026 Pazartesi Günü itibari ile normal çalışma düzenimize devam edilecektir.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            Bu vesileyle Ramazan Bayramınızın Mübarek olmasını dileriz. Hayırlı Bayramlar…
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text)",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            iyziteam
          </p>
          <Button className="iyzi-button-blue" onClick={handleClose}>
            Tamam
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangePasswordInfo;
